import { frontendURL } from 'dashboard/helper/URLHelper';

// custom (2026-08-27): SAÚDE DO WHATSAPP — diagnóstico da caixa, item de administração.
//
// `permissions` é só administrador, e a razão é de papel, não de sigilo: os sinais desta
// tela — silêncio da caixa, fila, contatos sem nome, conversas partidas — não têm ação de
// atendimento. Quem atende não conserta nenhum deles, e uma tela de alarme para quem não
// pode agir só produz ansiedade. O backend repete a mesma regra (WhatsappDiagnosticsPolicy),
// porque permissão de rota é conveniência de navegação, não segurança.
//
// SEM flag por conta, de propósito, igual à trilha de auditoria: saber se as mensagens estão
// chegando não é funcionalidade opcional de produto — é a pergunta que decide se a
// plataforma está de pé.
export const whatsappSaudeRoutes = [
  {
    path: frontendURL('accounts/:accountId/whatsapp-saude'),
    name: 'whatsapp_saude',
    component: () => import('./WhatsappSaude.vue'),
    meta: {
      permissions: ['administrator'],
    },
  },
];
